import { OtpViewModel } from '@apis/model';
import { InfoResponse } from '@ul/api';

export const toOtpTypeViewModel = (response: InfoResponse): OtpViewModel[] | undefined => {
    const { otpTypesInfo } = response;
    if (!otpTypesInfo || otpTypesInfo.length == 0) {
        return;
    }

    return otpTypesInfo.map(o => {
        return {
            target: o.target,
            token: o.token,
            otpType: o.otpType,
            refCode: o.refCode,
        };
    });
};
